import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { BankTransactionsSummary } from '@portal-workspace/grow-shared-library';
import { LooseCurrencyPipe } from '../../pipes/loose-currency.pipe';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

@Component({
    selector: 'non-preferred-lender-summary',
    templateUrl: './non-preferred-lender-summary.component.html',
    styleUrls: ['./non-preferred-lender-summary.component.scss'],
    standalone: true,
    imports: [MatTableModule, NgClass, ExtendedModule, LooseCurrencyPipe]
})
export class NonPreferredLenderSummaryComponent implements OnInit, OnChanges {
  @Input({ required: true }) data!: BankTransactionsSummary;
  dataSource: BankTransactionsSummary[] = [];
  columnsToDisplay: string[] = ['totaldebit', 'numdebit'];
  moreWidth: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.data) {
      this.dataSource = [this.data];
    }

    if (this.data?.numcredit && this.data?.numcredit > 0) {
      this.columnsToDisplay = ['totaldebit', 'numdebit', 'totalcredit', 'numcredit'];
      this.moreWidth = true;
    }
  }

  ngOnChanges() {
    this.moreWidth = false;
    this.columnsToDisplay = ['totaldebit', 'numdebit'];
    if (this.data) {
      this.dataSource = [this.data];
    }

    if (this.data?.numcredit && this.data?.numcredit > 0) {
      this.columnsToDisplay = ['totaldebit', 'numdebit', 'totalcredit', 'numcredit'];
      this.moreWidth = true;
    }
  }

  getColumnTitles(column: string): string {
    switch (column) {
      case 'totaldebit': return '$ Repayments';
      case 'totalcredit': return '$ Loan Advanced';
      case 'numdebit': return '# Repayments';
      case 'numcredit': return '# Loan Advanced';
      default: return column;
    }
  }

  needCurrencyPipe(column: string) {
    return ['totaldebit', 'totalcredit'].includes(column);
  }
}
